import { api } from 'data/api/api'

import { RequestFurtherHelpArgs } from '../types/further-help'

export const requestFurtherHelp = (args: RequestFurtherHelpArgs) =>
  api.post(`/users/${args.userId}/msg_threads/${args.conversationId}/request_further_help`, {
    help_center_session_id: args.helpCenterSessionId,
  })
